/** Safety service client — content filter rules, blocklist/allowlist, audit. */
import { api } from './client';

export interface Category {
  slug: string;
  name: string;
  description: string;
  default_block: boolean;
  sort_order: number;
}

export interface CategoryRule {
  slug: string;
  blocked: boolean;
  source: 'default' | 'child';
}

export interface BlocklistEntry {
  id: string;
  domain: string;
  note: string | null;
  created_at: string;
}

export interface AllowlistEntry {
  id: string;
  domain: string;
  note: string | null;
  created_at: string;
}

export interface ChildRules {
  child_id: string;
  family_id: string;
  categories: CategoryRule[];
  blocklist: BlocklistEntry[];
  allowlist: AllowlistEntry[];
}

export interface BlockEvent {
  id: string;
  child_id: string;
  domain: string;
  url: string | null;
  decision: string;
  reason: string;
  category_slug: string | null;
  occurred_at: string;
}

export const safetyApi = {
  listCategories: () => api<Category[]>('/v1/safety/categories'),
  getRules: (childId: string) => api<ChildRules>(`/v1/safety/children/${childId}/rules`),
  updateCategories: (
    childId: string,
    rules: { slug: string; blocked: boolean }[],
  ) =>
    api<CategoryRule[]>(`/v1/safety/children/${childId}/rules/categories`, {
      method: 'PUT',
      body: { rules },
    }),
  addBlocklist: (childId: string, domain: string, note?: string) =>
    api<BlocklistEntry>(`/v1/safety/children/${childId}/blocklist`, {
      method: 'POST',
      body: { domain, note },
    }),
  removeBlocklist: (childId: string, entryId: string) =>
    api<void>(`/v1/safety/children/${childId}/blocklist/${entryId}`, {
      method: 'DELETE',
    }),
  addAllowlist: (childId: string, domain: string, note?: string) =>
    api<AllowlistEntry>(`/v1/safety/children/${childId}/allowlist`, {
      method: 'POST',
      body: { domain, note },
    }),
  removeAllowlist: (childId: string, entryId: string) =>
    api<void>(`/v1/safety/children/${childId}/allowlist/${entryId}`, {
      method: 'DELETE',
    }),
  listEvents: (childId: string, limit = 50) =>
    api<BlockEvent[]>(`/v1/safety/children/${childId}/events?limit=${limit}`),
};
